<template>
  <div>
    <v-app-bar
      v-if="isDesktop"
      app
      fixed
      height="72px"
      :elevation="scrolled ? 4 : 0"
      class="durable-transition subscription"
    >
      <v-container>
        <v-row>
          <a
            href="/"
            class="subtitle-2"
          >
            <v-img
              src="@/assets/images/logo-britecheck.svg"
              style="width: 220px; height: 36px;"
            />
          </a>
          <v-spacer />
          <div>
            <div v-if="isDesktop">
              <div class="d-inline" v-if="!isLoggedIn">
                <v-btn to="/login" text class="link-navbar">
                  <span class="change-font">
                    <div class="link-before"></div> SIGN IN
                  </span>
                </v-btn>
                <v-btn to="/register" style="background-color: #7972c0; color: white">
                  <span class="change-font">SIGN UP</span>
                </v-btn>
              </div>
              <div v-else class="d-inline"><UserTopMenu /></div>
            </div>
            <v-icon v-else color="#118BBB" @click="handleResponsiveMenu()"
            >mdi-format-align-left</v-icon
            >
          </div>
        </v-row>
      </v-container>
    </v-app-bar>
    <v-app-bar
      v-else
      app
      fixed
      height="64px"
      :elevation="4"
      :color="navBarColol"
      class="durable-transition subscription"
    >
      <v-row class="flex-nowrap align-center" :class="{ 'px-8': isMobile }">
        <a
          href="/"
          class="subtitle-2"
        >
          <v-img
            src="@/assets/images/logo-britecheck.svg"
            style="width: 220px; height: 36px;"
          />
        </a>
        <v-spacer />
        <v-icon color="#118BBB" @click="handleResponsiveMenu()"
        >mdi-format-align-left</v-icon
        >
      </v-row>
      <v-expansion-panels
        flat
        v-model="showResponsiveNav"
        style="position: absolute; top: 98%; left: 0px"
      >
        <v-expansion-panel>
          <v-expansion-panel-content>
            <v-card :class="{ 'px-8': isMobile }" flat>
              <div class="d-flex column" v-if="!isLoggedIn">
                <v-btn to="/login" text class="link-navbar">
                  <span class="change-font">
                    <div class="link-before"></div> SIGN IN
                  </span>
                </v-btn>
                <v-btn to="/register" style="background-color: #7972c0; color: white">
                  <span class="change-font">SIGN UP</span>
                </v-btn>
              </div>
              <div v-else class="d-inline"><UserTopMenu /></div>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-app-bar>
  </div>
</template>

<script>
// import TopBar from '@/components/top-bar/TopBar'
import UserTopMenu from '@/components/top-bar/UserTopMenu'
export default {
  components: {
    // TopBar
    UserTopMenu
  },
  name: 'NavBar',
  props: ['isWhite'],
  data() {
    return {
      scrolled: false,
      links: [
        { icon: 'mdi-link', text: 'HOME', route: '/index' },
        { icon: 'mdi-link', text: 'PRICING', route: '/pricing' },
        {
          icon: 'mdi-link',
          text: 'SUPPORT',
          href: 'https://britecheck.zendesk.com',
          target: '_blank'
        }
      ],
      showResponsiveNav: -1,
      isLoggedIn: false
    }
  },
  computed: {
    isDesktop() {
      return this.$vuetify.breakpoint.mdAndUp
    },
    isMobile() {
      return this.$vuetify.breakpoint.smOnly
    },
    navBarColol() {
      if (this.scrolled) {
        return 'white'
      } else {
        if (this.isWhite) {
          return 'white'
        } else {
          return '#f5f5f5'
        }
      }
    }
  },
  mounted() {
    if (!localStorage.getItem('curUserData') && !!localStorage.getItem('querytoken')) {
      this.$store.dispatch('user/getUserByToken', localStorage.getItem('querytoken')).then((response) => {
        if (response) {
          localStorage.removeItem('querytoken')
          this.$router.go(this.$router.currentRoute)
        }
      })
    }
    const curUserData = JSON.parse(localStorage.getItem('curUserData'))
    if (curUserData !== null) this.isLoggedIn = true
    else this.isLoggedIn = false
    window.onscroll = () => {
      this.changeColor()
    }
  },
  methods: {
    changeColor() {
      if (
        document.body.scrollTop > 50 ||
        document.documentElement.scrollTop > 50
      ) {
        this.scrolled = true
        this.showResponsiveNav = -1
      } else {
        this.scrolled = false
      }
    },
    handleResponsiveMenu() {
      if (this.showResponsiveNav < 0) {
        this.showResponsiveNav = 0
      } else {
        this.showResponsiveNav = -1
      }
    }
  }
}
</script>

<style lang="scss">
.subscription .v-image__image--cover {
  background-size: contain !important;
}
</style>

<style lang="scss">
.subscription {
  background-color: #ffffff !important;
}
.change-font {
  font-family: 'Raleway', sans-serif;
}
.durable-transition {
  transition: all 0.5s;
}
.try-button {
  background: linear-gradient(
    45deg,
    rgba(82, 79, 117, 1) 0%,
    rgba(119, 114, 181, 1) 100%
  );
  color: white !important;
  width: 200px;
  height: 35px !important;
}
.responsive-link-navbar {
  &:hover {
    &:before {
      content: '';
      height: 2px;
      width: 10px;
      background-color: #5f55b8;
      position: absolute;
      top: 50%;
      left: 0;
    }
  }
}
.v-btn__content {
  .change-font {
    font-size: 14px;
    font-weight: 800 !important;
    letter-spacing: normal;
  }
}
.link-navbar {
  color: #393939 !important;

  &:hover {
    .link-before {
      height: 3px;
      width: 10px;
      content: '';
      position: absolute;
      top: 6px;
      left: -13px;
      background-color: #5f55b8;
    }
  }
}
.signinup {
  display: inline-block;
}
.theme--light.v-btn--active:hover::before,
.theme--light.v-btn--active::before {
  opacity: 0;
}
.theme--light.v-btn:hover::before {
  opacity: 0;
}
</style>
